class FpSizeConfirmation extends HTMLElement {
  connectedCallback() {
    this.controller?.abort();
    this.controller = new AbortController();
    const signal = this.controller.signal;
    this.checkbox = this.querySelector('input[type="checkbox"]');
    this.sizeInput = this.querySelector('[data-fp-confirmed-size]');
    this.variantInput = this.querySelector('[data-fp-confirmed-variant]');
    this.error = this.querySelector('[data-fp-size-error]');
    this.form = this.closest('form');
    this.scope = this.closest('.shopify-section') || this.parentElement;
    this.reset();
    this.checkbox.addEventListener('change', () => {
      const confirmed = this.checkbox.checked;
      this.sizeInput.value = this.currentSize();
      this.variantInput.value = confirmed ? this.currentVariant() : '';
      this.sizeInput.disabled = !confirmed;
      this.variantInput.disabled = !confirmed;
      this.checkbox.setCustomValidity('');
      this.checkbox.removeAttribute('aria-invalid');
      this.error.hidden = true;
    }, {signal});
    this.scope.addEventListener('change', (event) => {
      const picker = event.target.closest('variant-picker');
      if (picker?.dataset.productId === this.dataset.productId) this.reset();
    }, {capture:true, signal});
    this.form.addEventListener('submit', (event) => {
      if (!this.validate()) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    }, {capture:true, signal});
    this.form.addEventListener('invalid', (event) => {
      if (event.target === this.checkbox) this.showError();
    }, {capture:true, signal});
  }
  disconnectedCallback() { this.controller?.abort(); }
  currentVariant() { return this.form?.querySelector('input[name="id"]')?.value || ''; }
  currentSize() {
    const picker = Array.from(this.scope.querySelectorAll('variant-picker')).find(el => el.dataset.productId === this.dataset.productId);
    const option = Array.from(picker?.querySelectorAll('input:checked, option:checked') || []).find(el => el.dataset.optionName === this.dataset.sizeName);
    return option?.value || this.dataset.currentSize;
  }
  sync() {
    const size = this.currentSize();
    this.querySelector('[data-fp-selected-size]').textContent = size;
    this.sizeInput.value = size;
  }
  reset() {
    if (!this.checkbox) return;
    this.checkbox.checked = false;
    this.checkbox.setCustomValidity('');
    this.sizeInput.disabled = true;
    this.variantInput.disabled = true;
    this.variantInput.value = '';
    this.error.hidden = true;
    this.sync();
  }
  showError() {
    this.error.hidden = false;
    this.checkbox.setAttribute('aria-invalid', 'true');
    this.scrollIntoView({block:'center', behavior:'smooth'});
    this.checkbox.focus({preventScroll:true});
  }
  validate(variantId) {
    this.sync();
    const id = String(variantId || this.currentVariant());
    if (!this.checkbox.checked || !id || this.variantInput.value !== id || this.sizeInput.value !== this.currentSize()) {
      this.checkbox.checked = false;
      this.sizeInput.disabled = true;
      this.variantInput.disabled = true;
      this.showError();
      return false;
    }
    this.checkbox.removeAttribute('aria-invalid');
    this.error.hidden = true;
    return true;
  }
}
if (!customElements.get('fp-size-confirmation')) customElements.define('fp-size-confirmation', FpSizeConfirmation);
